import {AHorzScroller} from "../abstract/AHorzScroller";

export class CartesSliderMobile extends AHorzScroller {
    initialize(params) {
        super.initialize(params);

        this.$$items = '.carte';
    }

}